import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";

import { useStoryblokProductsFromUuids } from "../../../hooks/useStoryblokProducts";
import { RenderStoryblokComponent } from "../../../helpers/bloksRenderer";

import styles from "./curatedProductsListingPanel.module.scss";

function CuratedProductsListingPanel({ blok, story_language }) {
  const products = useStoryblokProductsFromUuids(blok.products);
  if (products && products.length === 0) {
    return null;
  }
  return (
    <SBEditable withClass={styles.root} blok={blok}>
      {products && products.length > 0 ? (
        <>
          <ListingHeader underlineColor={blok.header_underline_color}>
            <h2>{blok.header}</h2>
          </ListingHeader>
          {products.map((itemBlok) => {
            return (
              <div className={styles.itemWrapper} key={itemBlok._uid}>
                {RenderStoryblokComponent(itemBlok, null, story_language)}
              </div>
            );
          })}
        </>
      ) : null}
    </SBEditable>
  );
}

export default CuratedProductsListingPanel;
